import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import LavorisService from "../../services/LavorisService";
import { UpdateParticularPatientRequestService } from "../../services/ParticularPatient/ParticularPatient.type";
import StyledWrapper from "./styleParticular";
import { PhoneNumber } from "../../utils/phoneNumber";

const DataParticularPatient = () => {
    const LavorisInstance = LavorisService.getInstance();
    // useStates
    const [data, setData] = useState<any>([]);
    const [searchParams, setSearchParams] = useSearchParams("");

    // useEffects
    useEffect(() => {
        const getCompanyProfile = async () => {
            try {
                const particularPatientProfile: UpdateParticularPatientRequestService =
                    await LavorisInstance.ParticularPatient.getParticularPatientProfile();
                if (particularPatientProfile) {
                    setData(particularPatientProfile);
                }
            } catch (e) {
                console.log(e);
            }
        };
        getCompanyProfile();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const updateBiologicalSex = (sex?: string) => {
        let updateBiologicalSex = sex?.toLowerCase();
        return updateBiologicalSex = updateBiologicalSex === "femenino" ? "Femenino" : "Masculino";
    }






    return (
        <>
            {/* DATOS PERSONALES */}
            <div className="company-data">
                <div className="container-fluid">
                    <div className="row g-4">

                        {/* Datos Personales */}
                        <div className="col-12 col-lg-4">
                            <div className="company-section">
                                <h3 className="section-title">Datos Personales</h3>

                                <div className="company-field">
                                    <label>Apellido y Nombre</label>
                                    <span>{data?.name || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Ocupación</label>
                                    <span>{data?.job || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>CUIL</label>
                                    <span>{data?.cuil || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>DNI</label>
                                    <span>{data?.DNI || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Fecha de nacimiento</label>
                                    <span>{data?.birthDate || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Sexo biológico</label>
                                    <span>{updateBiologicalSex(data?.sex) || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Género</label>
                                    <span>{data?.genre || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Estado civil</label>
                                    <span>{data?.maritalStatus || "Pendiente"}</span>
                                </div>
                            </div>
                        </div>

                        {/* Datos de Contacto */}
                        <div className="col-12 col-lg-4">
                            <div className="company-section">
                                <h3 className="section-title">Datos de Contacto</h3>

                                <div className="company-field">
                                    <label>Provincia</label>
                                    <span>{data?.province || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Ciudad</label>
                                    <span>{data?.location || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Código postal</label>
                                    <span>{data?.postalCode || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Dirección</label>
                                    <span>{data?.fullAddress || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Teléfono</label>
                                    <span>{PhoneNumber(data?.phoneNumber) || "Pendiente"}</span>
                                </div>
                            </div>
                        </div>

                        {/* Cuentas de Usuario */}
                        <div className="col-12 col-lg-4">
                            <div className="company-section">
                                <h3 className="section-title">Cuentas de usuario</h3>

                                <div className="company-field">
                                    <label>Email</label>
                                    <span>{data?.email || "Pendiente"}</span>
                                </div>

                                <div className="company-field">
                                    <label>Comentarios</label>
                                    <span>{data?.comment || "Pendiente"}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default DataParticularPatient;
